import { profileCreationSteps } from '@/helpers/constants';
import gql from 'graphql-tag';

/**
 * stepQueries is an object, constructed by constants and their respective queries
 * It is made for automation and simplification of check's process during the
 * profile setup
 *
 * Each "step" contains few parameters like so:
 * query <string>: the query itself - set with "step" alias to unify the checks later on
 * whereField<string>: describe the field that will be used in where clause
 * returnValue <boolean>: determine whether the content of the response have to be returned or not.
 */
export const stepQueries = {
	[profileCreationSteps.INTERESTS]: {
		query: `
    step: studentInterests(where: $where) {
      interest_ID
    }`,
		whereField: 'studentId',
		returnValue: false
	},
	[profileCreationSteps.KNOWLEDGE]: {
		query: `
    step: studentQuestionAnswers(where: $where) {
      questionId: simulation_Lifestyle_Questions_ID
      studentId
    }
    `,
		whereField: 'studentId',
		returnValue: true
	}
};

export const profileLockFragment = gql`
	fragment passcodeLockStages on StudentObjectGraphType {
		isAfterAllocateSavingsUnlockedWithPasscode
		isAfterSetBudgetUnlockedWithPasscode
		isAfterLifeScenarioUnlockedWithPasscode
		isAfterLifeStageSummaryUnlockedWithPasscode
		isAfterCalculateNMIUnlockedWithPasscode
		isAfterLifeStageIntroUnlockedWithPasscode
		passcodes: studentUnlockCodes {
			afterAllocateSavingsPasscode
			afterSetBudgetPasscode
			afterLifeScenarioPasscode
			afterLifeStageSummaryPasscode
			afterCalculateNMIPasscode
			afterLifeStageIntroPasscode
		}
	}
`;
